import { Component } from '@angular/core';
import { DocHit, DocHitType } from '@models/review/doc-hit';
import { DocHitsService } from '@services/doc-hits.service';
import { combineLatest, filter, map, Observable, share, switchMap } from 'rxjs';
import { BaseComponent } from 'src/app/components/base.component';
import { DocViewerStore } from '@store/legacy/doc-viewer.store';
import { iFrameUrlFactory } from '@utilities/iframe-url-factory';
import { TabStates } from '@utilities/tab-states';
import { MainTabIndices } from '@enums/main-tab-indices.enum';
import { distinctUntilChanged } from 'rxjs/operators';
import { ReviewManager } from '@managers/review.manager';
import { Store } from "@ngrx/store";
import { DocViewerActions  } from "@store/doc-viewer/doc-viewer.actions";
import { documentViewActions } from "@store/doc-viewer/document-view/document-view.actions";

@Component({
    selector: 'lex-hits-panel',
    templateUrl: './hits-panel.component.html',
    styleUrls: ['./hits-panel.component.scss'],
    standalone: false
})
export class HitsPanelComponent extends BaseComponent {
	public normalizedHits$: Observable<DocHit[]>;
	public metadataHits$: Observable<DocHit[]>;
	public insightHits$: Observable<DocHit[]>;
	public nativeHits$: Observable<DocHit[]>;
	public translatedHits$: Observable<DocHit[]>;

	constructor(
		public docHitsService: DocHitsService,
		public docViewerStore: DocViewerStore,
		private iFrameUrlFactory: iFrameUrlFactory,
		private tabStates: TabStates,
		private reviewManager: ReviewManager,
		private store: Store
	) {
		super();

		const hits$ = combineLatest([
			this.docViewerStore.simpleState$,
			this.docViewerStore.currentDocument$,
			this.tabStates.currentSelectedTabIndex$
		]).pipe(
			filter(([,,selected]) => selected === MainTabIndices.Hits),
			distinctUntilChanged(([,aDoc,],[,bDoc,]) => aDoc.docId === bDoc.docId),
			switchMap(([, document]) => this.docHitsService.getHits(document.docId)),
			share(),
			filter((x) => !!x)
		);

		this.normalizedHits$ = hits$.pipe(
			map((hits) => hits.filter(h => h.type === DocHitType.Normalized))
		);
		this.metadataHits$ = hits$.pipe(
			map((hits) => hits.filter(h => h.type === DocHitType.Metadata))
		);
		this.insightHits$ = hits$.pipe(
			map((hits) => hits.filter(h => h.type === DocHitType.Insights))
		);
		this.nativeHits$ = hits$.pipe(
			map((hits) => hits.filter(h => h.type === DocHitType.Native))
		);
		this.translatedHits$ = hits$.pipe(
			map((hits) => hits.filter(h => h.type === DocHitType.Translated))
		);
	}

	public navigateToPage(pageNumber: number): void {
		this.reviewManager.goToPage(pageNumber);
    this.store.dispatch(DocViewerActions.pdfPageUpdate({ selectedPage: 0 }));
    this.store.dispatch(DocViewerActions.pdfPageUpdate({ selectedPage: pageNumber }));
		this.store.dispatch(documentViewActions.viewUpdated({ selectedView: 'pdf'}));
	}
}
